import React from 'react';
import { EVENT_STATUS, ACTIVE_HOMESCREEN } from '../../enums';
import { connect } from 'react-redux';
import { isSaaSAdmin } from '@/redux/util';
import { defaultWidgets } from '../Widgets';
import {
	defaultThemeSaaSJSON,
	defaultThemeJSON,
} from 'routes/EventDetail/routes/Theme/defaultTheme';
import { DEFAULT_ROUTES_STR } from 'routes/EventDetail/routes/Navigation/Routes';

import EventCreate from './EventCreate';

const EventCreateContainer = props => {
	const { adminSSOProfile, auth0Token, onCreate, socket, currentClientID } = props;

	const onFinish = values => {
		const { name, status, location, image_url } = values;
		var date = new Date();
		const emitVars = {
			name,
			location,
			event_image_url: image_url,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York', //make try?
			start_time: new Date().toISOString(),
			end_time: new Date(date.setMonth(date.getMonth() + 1)).toISOString(),
			status: status ? EVENT_STATUS.ACTIVE : EVENT_STATUS.INACTIVE,
			client_id: currentClientID,
			active_homescreen: isSaaSAdmin() ? ACTIVE_HOMESCREEN.WIDGET : ACTIVE_HOMESCREEN.STANDARD,
			theme: isSaaSAdmin() ? defaultThemeSaaSJSON : defaultThemeJSON,
			side_navigation: DEFAULT_ROUTES_STR,
		};
		console.log(emitVars);
		onCreate(null, false);

		setTimeout(() => {
			socket.emit('event/POST', emitVars, adminSSOProfile.email, auth0Token, defaultWidgets);
		}, 2700);
	};

	return <EventCreate {...props} onFinish={onFinish} />;
};

const msp = ({ auth, ws, clients }) => ({
	adminSSOProfile: auth.adminSSOProfile,
	auth0Token: auth.auth0Token,
	socket: ws.socket,
	currentClientID: clients.currentClient.id,
});

const mdp = () => ({});

export default connect(msp, mdp)(EventCreateContainer);
